import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Flex, Icon, Text } from 'roo-ui/components';
import PropTypes from 'prop-types';
import NumberOfNights from 'components/NumberOfNights';
import Currency from 'components/Currency';
import PriceBeforeDiscount from 'components/PriceBeforeDiscount';
import { getQueryCheckIn, getQueryCheckOut } from 'store/search/searchSelectors/querySelectors';

const ConnectedNumberOfNights = () => {
  const checkIn = useSelector(getQueryCheckIn);
  const checkOut = useSelector(getQueryCheckOut);
  return <NumberOfNights checkIn={checkIn} checkOut={checkOut} color="greys.steel" fontSize="sm" />;
};

const OfferBreakdown = ({ total, totalBeforeDiscount, hasDiscount, offerType }) => {
  const isCashCurrency = total.currency !== 'PTS';
  const isClassic = offerType === 'classic';

  return (
    <Flex flexDirection="column" alignItems="flex-end">
      <Text color="greys.steel" fontSize="sm" data-testid="number-of-nights">
        <ConnectedNumberOfNights />{' '}
        <Text data-testid="from-currency">
          from{` `}
          {isCashCurrency ? `(${total.currency})` : ''}
        </Text>
      </Text>
      <Flex alignItems="baseline">
        {hasDiscount && (
          <Box>
            <PriceBeforeDiscount total={totalBeforeDiscount} roundToCeiling hideCurrency={isCashCurrency} mr={1} />
          </Box>
        )}
        <Flex alignItems="flex-end" data-testid="price">
          {isClassic && <Icon name="ribbon" size={[28, 32]} color="brand.primary" data-testid="classic-ribbon" />}
          <Currency {...total} color="brand.primary" fontSize={['28px', 'xl']} fontWeight="bold" roundToCeiling hideCurrency />
          {!isCashCurrency && (
            <Text fontSize={['xs', 'sm']} fontWeight="bold" color="brand.primary" px={1} data-testid="currency-points">
              PTS
            </Text>
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};

OfferBreakdown.propTypes = {
  total: PropTypes.object.isRequired,
  totalBeforeDiscount: PropTypes.object,
  hasDiscount: PropTypes.bool,
  offerType: PropTypes.string,
};

OfferBreakdown.defaultProps = {
  totalBeforeDiscount: {},
  hasDiscount: false,
  offerType: undefined,
};

export default OfferBreakdown;
